import React, { useState } from "react";
import { Typography, TableContainer, TextField, Box, Paper, useTheme, useMediaQuery } from '@mui/material';

/**
 * 質問の回答
 *
 * @param questionValue 質問内容オブジェクト
 * @returns 質問の内容エリア
 */
export const QuestionAnswer = ({ questionValue, formRef }: any) => {
  // 初期値をquestionValueまたはformRefから取得
  const [localValue, setLocalValue] = useState<string>(formRef.questionAnswer.current || questionValue.questionAnswer || "");

  // レスポンシブデザイン設定
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // モバイル画面の条件設定

  // 入力変更時に親コンポーネントに値を通知
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setLocalValue(newValue); // ローカルの状態を更新
    if (formRef.questionAnswer.current !== null) {
      formRef.questionAnswer.current = newValue; // useRefの値を更新
    }
  };

  // 質問の内容がnullや空文字の場合は何も表示しない
  if (questionValue.value === null || !questionValue.questionContent) {
    return <></>;
  }

  return (
    <TableContainer component={Paper} sx={{ border: '1px solid #DDDDDD', margin: isMobile ? "10px auto" : "20px auto", backgroundColor: '' }}>
      {/* "質問の回答"バー */}
      <Typography
        sx={{
          color: '#fff',
          backgroundColor: '#3f51b5',
          padding: isMobile ? '8px' : '10px', // モバイルではパディングを少し小さく
          textAlign: 'center',
          borderRadius: '5px',
        }}
      >
        質問
      </Typography>

      {/* 質問文 */}
      <Typography sx={{
        margin: isMobile ? '10px 0' : '20px 0', 
        textAlign: 'center', 
        fontSize: isMobile ? '14px' : '16px' // モバイルではフォントサイズを少し小さく
      }}>
        {questionValue.questionContent}
      </Typography>

      {/* 入力エリア */}
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        padding: isMobile ? '10px' : '20px' // モバイルではパディングを少し小さく
      }}>
        <TextField
          value={localValue}
          multiline
          minRows={isMobile ? 3 : 5} // モバイルでは行数を減らす
          maxRows={10}
          placeholder="入力してください"
          variant="outlined"
          fullWidth
          onChange={handleInputChange}
          label='質問の回答'
          disabled={questionValue.questionAnswer != null && questionValue.questionAnswer !== ''}
          sx={{
            backgroundColor: (questionValue.questionAnswer != null && questionValue.questionAnswer !== '') ? '#f0f0f0' : 'white',
            resize: 'none',
          }}
        />
      </Box>
    </TableContainer>
  );
};
